export enum AccountSettingsMutationKey {
  PATCH_ACCOUNT_SETTINGS = 'patch-account-settings',
}
